import { createContext, useRef } from 'react'
import { CompProps } from 'types'
import { StatsModalCtxType } from './types'
import { createStatsModalStore } from './store'

type CTX = StatsModalCtxType

export const StatsModalContext = createContext({} as CTX)

export const StatsModalProvider = ({ children, ...props }: CompProps) => {
  const storeRef = useRef<CTX>()

  if (!storeRef.current) {
    storeRef.current = createStatsModalStore()
  }

  return (
    <StatsModalContext.Provider value={storeRef.current}>
      {children}
    </StatsModalContext.Provider>
  )
}
